/**
 * useMobile — returns true on screens narrower than the md breakpoint (768px).
 * Responds to orientation changes and window resizes via matchMedia listener.
 * SSR-safe (returns false before hydration).
 */
import { useEffect, useState } from 'react';

const BREAKPOINT = '(max-width: 767px)';

export function useMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') {return false;}
    return window.matchMedia(BREAKPOINT).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(BREAKPOINT);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
